<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div ref="tpl">
      <div class="p-6 standard-form">
        <!-- hack to not focus the first input -->
        <div style="max-width: 0; max-height: 0; overflow: hidden;">
          <input autofocus="true" />
        </div>
        <!-- end hack -->
        <div class="pb-4 text-xl">Drop {{ roleName }}</div>

        <div class="standard-field-wrapper">
          <label for="ineffective_date">Drop Date</label>
          <div class="standard-input-wrapper">
            <div class="standard-input-container">
              <input type="text" name="ineffective_date" ref="datepicker" v-model="date" class="datepicker">
            </div>
          </div>

          <label for="ineffective_reason">Reason</label>
          <div class="standard-input-wrapper">
            <div class="standard-input-container">
              <textarea rows="6" name="ineffective_reason" v-model="ineffective_reason"></textarea>
            </div>
          </div>
        </div>

        <div class="flex flex-row justify-end mt-4">
          <button class="btn btn-primary mr-2" @click="dropTimothy()">Drop</button>
          <button class="btn btn-secondary" @click="closeModal()">Cancel</button>
        </div>
      </div>
    </div>
    
  </VueFinalModal>
</template>

<script setup>
  import axios from 'axios'
  import flatpickr from 'flatpickr'
  import { capitalize } from 'lodash-es'
  import { onMounted, ref, reactive, computed } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let timothy = ref({})
  let date = ref('')
  let ineffective_reason = ref('')
  let datepicker = ref()

  onMounted(() => {
    timothy.value = props.params.data.timothy

    let today = new Date()
    date.value = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`

    setUpDatePicker()
  })

  const roleName = computed(() => {
    return capitalize(timothy.value.role)
  })


  function setUpDatePicker () {
    let itvl = setInterval(() => {
      if (datepicker.value) {
        flatpickr(datepicker.value)
        clearInterval(itvl)
      }
    }, 50)
  }

  function closeModal () {
    emit('close')
  }

  async function dropTimothy () {
    try {
      await axios.put(`/person_roles/${timothy.value.id}.json`, {
        state: 'dropped',
        ineffective_at: date.value,
        ineffective_reason: ineffective_reason.value,
        return_path: `/training_centers/${timothy.value.relatable_id}`,
      })
    } catch(error) {
      window.Rollbar.error('Error dropping Timothy', error)
      alert('Error occured dropping Timothy')
    } finally {
      closeModal()
      location.reload(true)
    }
  }

</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }

  .bold {
    font-weight: bold;
  }

  .pad {
    margin: 5px;
  }
</style>
